import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import React from 'react';

import { useTranslator } from '@/hooks/useTranslator';
import { SelectItem, SelectItemWithDescription } from '@/types/fields';

interface Props {
  readonly item?: SelectItem | SelectItemWithDescription;

  onClick?(value: string): void;
}

export const CustomeSelectItem: React.FC<Props> = (props: Props): React.ReactElement => {
  const { item, onClick } = props;

  const tr = useTranslator();

  const handleClick = React.useCallback((): void => {
    if (item) {
      onClick?.(item.value);
    }
  }, [onClick, item]);

  if (!item) {
    return <MenuItem value="" />;
  }

  return (
    <MenuItem value={item.value} onMouseDown={ignore} onClick={handleClick}>
      <Tooltip title={tr(item.label)}>
        <Box width="100%">
          <Typography variant="body2" color="inherit" textOverflow="ellipsis" noWrap>
            {tr(item.label)}
          </Typography>
          {'description' in item && typeof item.description === 'string' && (
            <Typography variant="body1" color="custom.LightGray" textOverflow="ellipsis" noWrap>
              {tr(item.description)}
            </Typography>
          )}
        </Box>
      </Tooltip>
    </MenuItem>
  );
};

const ignore = (event: React.MouseEvent): void => {
  event.preventDefault();
};
